import { debounce } from 'throttle-debounce';

/**
 * Handle hero behaviors
 */
let Hero = {
	/**
	 * Entry point
	 */
	_init: () => {
		// listen for document ready.
		document.addEventListener('DOMContentLoaded', Hero._ready);
	},
	/**
	 * Handle document ready
	 */
	_ready: () => {
		// get hero rows.
		const rows = document.querySelectorAll('.hero-wrapper-row');

		// if they exist
		if (rows.length) {
			// loop through them
			rows.forEach(row => {
				// listen for custom event emitted by ThemeColor
				row.addEventListener('visible', Hero._visibilityHandler);
			});
		}

		window.addEventListener('resize', Hero._resizeHandler);
	},
	/**
	 * Handle visible row
	 */
	_visibilityHandler: debounce(10, (e) => {
		// get the text container and the active row
		const textContainer = document.querySelector('.hero-wrapper-text-desktop');
		let activeRow = e.target.closest('.hero-wrapper-row');

		// set the active class to the one that's visible
		activeRow.dataset.active = true;
	
		textContainer.classList.add('fade-out');

		// update text content and remove fade-out class
		setTimeout(() => {
			// update the text content
			textContainer.querySelector('.hero-wrapper-text-desktop-headline').innerHTML = activeRow.dataset.headline;
			textContainer.querySelector('.hero-wrapper-text-desktop-copy').innerHTML = activeRow.dataset.copy;
			
			const cta = textContainer.querySelector('.hero-wrapper-text-desktop-learnmore');
			cta.href = activeRow.dataset.ctaUrl;
			cta.textContent = activeRow.dataset.ctaTitle;

			// remove the fade-out class
			textContainer.classList.remove('fade-out');
		}, 400);
		
	}),
	_resizeHandler: () => {
		// on desktop
		if (window.offsetWidth >= 992) {
			// set active row
			ThemeColor._scrollObserver();
		}
		else {

		}
	}
};

// begin.
Hero._init();